import { useMemo } from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_STORE_DISTANCE } from '../queries.js';

const useStoreDistance = ()=>{
    const [getStoreDistance, { error , loading , data  }] = useLazyQuery(GET_STORE_DISTANCE);
    // @TODO investigate DistanceInMeters type and remove the StoreDistance type cast
    const { distance , timeByCar , timeByFoot  } = (data === null || data === void 0 ? void 0 : data.store) || {};
    return useMemo(()=>[
            getStoreDistance,
            {
                // set a clean attributes list if data is defined and undefined if data is undefined
                data: data ? {
                    distance,
                    timeByCar,
                    timeByFoot
                } : data,
                loading,
                error
            }, 
        ]
    , [
        data,
        distance,
        timeByCar,
        timeByFoot,
        loading,
        error,
        getStoreDistance
    ]);
};
var useStoreDistance$1 = useStoreDistance;

export { useStoreDistance$1 as default };
//# sourceMappingURL=use-store-distance.js.map
